<template>
  <div class="container mescroll-touch">
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require">*</span>
        <span class="title">1. 请输入姓名（填空）</span>
      </div>
      <div class="question_item_option">
        <input class="input" type="text" v-model="Name" placeholder="请输入">
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require">*</span>
        <span class="title">2. 请选择性别（单选）</span>
      </div>
      <div class="question_item_option">
        <van-radio-group v-model="Gender">
          <van-radio name="男" icon-size="22px" checked-color="#1D2A5A">A. 男</van-radio>
          <van-radio name="女" icon-size="22px" checked-color="#1D2A5A">B. 女</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require">*</span>
        <span class="title">3. 出生年月（**年**月）（填空）</span>
      </div>
      <div class="question_item_option">
        <input class="input" type="text" v-model="Birthday" placeholder="请输入">
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require">*</span>
        <span class="title">4. 政治面貌（单选）</span>
      </div>
      <div class="question_item_option">
        <van-radio-group v-model="ZZMM">
          <van-radio name="中共党员" icon-size="22px" checked-color="#1D2A5A">A. 中共党员</van-radio>
          <van-radio name="九三学社社员" icon-size="22px" checked-color="#1D2A5A">B. 九三学社社员</van-radio>
          <van-radio name="民革党员" icon-size="22px" checked-color="#1D2A5A">C. 民革党员</van-radio>
          <van-radio name="民盟盟员" icon-size="22px" checked-color="#1D2A5A">D. 民盟盟员</van-radio>
          <van-radio name="民建会员" icon-size="22px" checked-color="#1D2A5A">E. 民建会员</van-radio>
          <van-radio name="民进会员" icon-size="22px" checked-color="#1D2A5A">F. 民进会员</van-radio>
          <van-radio name="农工党党员" icon-size="22px" checked-color="#1D2A5A">G. 农工党党员</van-radio>
          <van-radio name="致公党党员" icon-size="22px" checked-color="#1D2A5A">H. 致公党党员</van-radio>
          <van-radio name="台盟盟员" icon-size="22px" checked-color="#1D2A5A">I. 台盟盟员</van-radio>
          <van-radio name="无党派人士" icon-size="22px" checked-color="#1D2A5A">J. 无党派人士</van-radio>
          <van-radio name="群众" icon-size="22px" checked-color="#1D2A5A">K. 群众</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require">*</span>
        <span class="title">5. 科室（单选）</span>
      </div>
      <div class="question_item_option">
        <van-radio-group v-model="Department">
          <van-radio name="皮肤科" icon-size="22px" checked-color="#1D2A5A">A. 皮肤科</van-radio>
          <van-radio name="其他" icon-size="22px" checked-color="#1D2A5A">B. <input class="radioInput" type="text" v-model="DepartmentInput" placeholder="请输入"></van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require">*</span>
        <span class="title">6. 请输入职称（填空）</span>
      </div>
      <div class="question_item_option">
        <input class="input" type="text" v-model="JobTitle" placeholder="请输入">
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require">*</span>
        <span class="title">7. 所在单位（填空）</span>
      </div>
      <div class="question_item_option">
        <input class="input" type="text" v-model="Company" placeholder="请输入">
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require">*</span>
        <span class="title">8. 请输入手机号（填空）</span>
      </div>
      <div class="question_item_option">
        <input class="input" type="text" v-model="Mobile" placeholder="请输入">
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require">*</span>
        <span class="title">9. 邮箱（填空）</span>
      </div>
      <div class="question_item_option">
        <input class="input" type="text" v-model="Mail" placeholder="请输入">
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <!-- <span class="require">*</span> -->
        <span class="title">10. 临床协作组（单选）</span>
      </div>
      <div class="question_item_option">
        <van-radio-group v-model="YZKLCXZZ">
          <van-radio name="新媒体传播" icon-size="22px" checked-color="#1D2A5A">A. 新媒体传播</van-radio>
          <van-radio name="特应性皮炎（AD）" icon-size="22px" checked-color="#1D2A5A">B. 特应性皮炎（AD）</van-radio>
          <van-radio name="银屑病" icon-size="22px" checked-color="#1D2A5A">C. 银屑病</van-radio>
          <van-radio name="毛发" icon-size="22px" checked-color="#1D2A5A">D. 毛发</van-radio>
          <van-radio name="荨麻疹" icon-size="22px" checked-color="#1D2A5A">E. 荨麻疹</van-radio>
          <van-radio name="功效性护肤品" icon-size="22px" checked-color="#1D2A5A">F. 功效性护肤品</van-radio>
          <van-radio name="痤疮" icon-size="22px" checked-color="#1D2A5A">G. 痤疮</van-radio>
          <van-radio name="皮肤外科" icon-size="22px" checked-color="#1D2A5A">H. 皮肤外科</van-radio>
          <van-radio name="激光" icon-size="22px" checked-color="#1D2A5A">I. 激光</van-radio>
          <van-radio name="注射美容" icon-size="22px" checked-color="#1D2A5A">J. 注射美容</van-radio>
          <van-radio name="中医" icon-size="22px" checked-color="#1D2A5A">K. 色素性疾病</van-radio>
          <van-radio name="其他" icon-size="22px" checked-color="#1D2A5A">L. <input class="radioInput" type="text" v-model="YZKLCXZZInput" placeholder="请输入"></van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="quesiton_item">
      <div class="quesiton_item_title">
        <span class="require"></span>
        <span class="title">11. 获取申请表，请添加以下微信</span>
      </div>
      <div class="question_item_option">
        <img src="@/assets/images/qrcode.jpg" class="qrcode" alt="">
      </div>
    </div>
    <div class="submit" @click="submit">确认提交</div>
  </div>
</template>

<script >
export default {
  name: 'Question',
  data() {
    return {
      Name: '',
      Gender: '',
      Birthday: '',
      ZZMM: '',
      Department: '',
      DepartmentInput: '',
      JobTitle: '',
      Company: '',
      Mobile: '',
      Mail: '',
      YZKLCXZZ: '',
      YZKLCXZZInput: ''
    }
  },
  created() {
    document.title = "华肤荟";
  },
  methods: {
    submit() {
      if(!this.Name || !this.Gender || !this.Birthday || !this.ZZMM || !this.Department || !this.JobTitle || !this.Company || !this.Mobile || !this.Mail) {
        this.$toast.fail('有必填项未填');
        return false;
      }

      if(this.Department == '其他' && !this.DepartmentInput) {
        this.$toast.fail('有必填项未填');
        return false;
      }

      // if(this.YZKLCXZZ == '其他' && !this.YZKLCXZZInput) {
      //   this.$toast.fail('有必填项未填');
      //   return false;
      // }

      const loadingToast = this.$toast.loading({
        message: '提交中...',
        duration: 0,
        forbidClick: true,
      });
      this.$axios.post('/api/api/web/customer/SubmitDy250220', {
        Name: this.Name,
        Gender: this.Gender,
        Birthday: this.Birthday,
        ZZMM: this.ZZMM,
        Department: this.Department == '其他' ? this.DepartmentInput : this.Department,
        JobTitle: this.JobTitle,
        Company: this.Company,
        Mobile: this.Mobile,
        Mail: this.Mail,
        YZKLCXZZ: this.YZKLCXZZ == '其他' ? this.YZKLCXZZInput : this.YZKLCXZZ
      }).then(res => {
        loadingToast.clear();
        this.$toast.success('提交成功');
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 10px;
  box-sizing: border-box;
  .quesiton_item {
    background-color: #f6f8f9;
    border-radius: 6px;
    margin-bottom: 12px;
    font-size: 14px;
  }
  .quesiton_item_title {
    color: #0c2941;
    line-height: 40px;
    padding: 0 10px;
    border-bottom: 1px solid #dddfe0;
    .require {
      color: red;
    }
  }
  .question_item_option {
    padding: 10px;
    box-sizing: border-box;
    .input {
      border: 1px solid #eee;
      width: 100%;
      height: 35px;
      line-height: 35px;
      border-radius: 4px;
      padding: 0 6px;
      box-sizing: border-box;
      font-size: 14px;
    }
  }
  .qrcode {
    display: block;
    width: 100%;
  }
  .submit {
    width: 100%;
    height: 35px;
    line-height: 35px;
    border-radius: 35px;
    background-color: #1D2A5A;
    color: #FFFFFF;
    text-align: center;
  }
}
.van-radio:not(:last-of-type) {
  margin-bottom: 15px;
}
.radioInput {
  border: 1px solid #eee;
  height: 35px;
  line-height: 35px;
  border-radius: 4px;
  padding: 0 6px;
  box-sizing: border-box;
  font-size: 14px;
}
</style>